import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, UntypedFormControl } from '@angular/forms';
import { GenericFormComponent } from '@app/helpers/generic-form-component';
import { EmployeeService } from '@app/services/employee.service';
import { UserService } from '@app/services/user.service';

declare var $: any;


@Component({
  selector: 'navigation-bar-employee-substitution',
  templateUrl: './navigation-bar-employee-substitution.component.html',
  animations: [
    trigger('shakeit', [
      state('shakestart', style({
        transform: 'scale(1)',
      })),
      state('shakeend', style({

      })),
      transition('shakestart => shakeend', animate('1200ms ease-in', keyframes([
        style({ transform: 'translate3d(-1px, 0, 0)', offset: 0.1 }),
        style({ transform: 'translate3d(2px, 0, 0)', offset: 0.2 }),
        style({ transform: 'translate3d(-4px, 0, 0)', offset: 0.3 }),
        style({ transform: 'translate3d(4px, 0, 0)', offset: 0.4 }),
        style({ transform: 'translate3d(-4px, 0, 0)', offset: 0.5 }),
        style({ transform: 'translate3d(4px, 0, 0)', offset: 0.6 }),
        style({ transform: 'translate3d(-4px, 0, 0)', offset: 0.7 }),
        style({ transform: 'translate3d(2px, 0, 0)', offset: 0.8 }),
        style({ transform: 'translate3d(-1px, 0, 0)', offset: 0.9 }),
      ]))),
    ])]
})
export class NavigationBarEmployeeSubstitutionComponent extends GenericFormComponent {

  @Output() eventOpenModal = new EventEmitter<MouseEvent>();
  @Output() eventSaveRecord = new EventEmitter<any>();
  @Input() idLink: string = '';

  setValue(flagSubstitute: number, employeeSubstitution: number) {

    if (flagSubstitute === 1) {
      this.substituteEnabled = true;
    }

    if (employeeSubstitution === 1) {
      this.employeeSubstitution.setValue(true, { emitEvent: false });

      setTimeout(() => {
        $(`#${this.idLink}`).collapse('show');
      }, 200);

      setTimeout(() => {
        this.shakeElement('shakeSubstitution')
      }, 2000);

    }


  }

  public substituteEnabled: boolean = false;
  public states = {};
  public _showContainer: boolean = false;

  constructor(
    private employeeService: EmployeeService,
    private userService: UserService) {



    super();
    this._formGroup = new FormGroup({
      employeeSubstitution: new UntypedFormControl(null),
    })

    this.employeeSubstitution.valueChanges.subscribe(e => {

      this.employeeSubstitution.disable({ emitEvent: false });

      if (this.employeeSubstitution.value === false) {
        this.employeeService.postEmployeeSubtitution(
          this.userService.getIdCurrentUser(),
          this.userService.getIdEmployee(),
          this.employeeSubstitution.value === true ? 1 : 0).toPromise().then((res: any) => {
            this.eventSaveRecord.next(this.employeeSubstitution.value);
          },
            err => {
              console.error(err);
            }
          );
      }
      else {
        this.eventSaveRecord.next(this.employeeSubstitution.value);
      }

      if (this.employeeSubstitution.value === true) {
        $(`#${this.idLink}`).collapse('show');

      }
      else {
        $(`#${this.idLink}`).collapse('hide');
      }

      this.employeeSubstitution.enable({ emitEvent: false });
    })
  }

  resetState() {
    $(`#${this.idLink}`).collapse('hide');
    this.employeeSubstitution.setValue(false, { emitEvent: false });
  }



  shakeElement(stateVar: string) {
    this.states[stateVar] = (this.states[stateVar] === 'shakestart' ? 'shakeend' : 'shakestart');
  }

  shakeEnd(stateVar: string, event) {
    this.states[stateVar] = 'shakeend';
  }

  onClickOpenModal(event: MouseEvent) {
    this.eventOpenModal.next(event);
  }

  showContainer() {
    this._showContainer = true;
  }

  updateValueSubstitute(value: any) {

    if (this.employeeSubstitution.value !== value) {
      this.employeeSubstitution.setValue(value, { emitEvent: false });

      if (this.employeeSubstitution.value === true) {
        $(`#${this.idLink}`).collapse('show');

      }
      else {
        $(`#${this.idLink}`).collapse('hide');
      }
    }



  }


  get employeeSubstitution() { return this._formGroup.get('employeeSubstitution') as FormControl; }
}